import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";

interface MetricsCardsProps {
  loading: boolean;
  metrics?: {
    uniqueCourses: number;
    totalSurveys: number;
    uniqueRecipients: number;
    uniqueInstructors: number;
  };
}

export function MetricsCards({ loading, metrics }: MetricsCardsProps) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Active Courses
            </Typography>
            <Typography variant="h4">
              {loading ? "-" : metrics?.uniqueCourses}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Surveys Sent
            </Typography>
            <Typography variant="h4">
              {loading ? "-" : metrics?.totalSurveys}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Students
            </Typography>
            <Typography variant="h4">
              {loading ? "-" : metrics?.uniqueRecipients}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Instructors
            </Typography>
            <Typography variant="h4">
              {loading ? "-" : metrics?.uniqueInstructors}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
